import { PageHeader } from 'components';
import { Button, Form, Table } from 'antd';
import styles from './style.module.scss';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';

import FormHelper from 'helpers/FormHelper';
import NotificationFormForEdit from 'components/modules/notificationFormForEdit';
import useInvoiceMonthlies from '../useInvoiceMonthlies';
import moment from 'moment';
import { FileExcelOutlined } from '@ant-design/icons';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    handleCreateOrUpdate,
    updateInProcess,
    shops,
    inactiveShops,
    singleItem,
    loading,
    handleApprove,
    approveErrors,
    handleDownloadExcel,
  } = useInvoiceMonthlies(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const title = isNew
    ? t('PUBBLICA FATTURATI MENSILE')
    : t('MODIFICA FATTURATI MENSILE');

  const data = singleItem?.allData?.data[0]?.rows || [];

  const taxableData = [
    {
      title: t('Fatturato Netto - inserito dal PdV (€)'),
      value: data[0]?.taxable,
    },
    {
      title: t('Fatturato Netto - riepilogo mensile (€)'),
      value: data[0]?.taxable_monthlies,
    },
    {
      title: t('Discrepanza Fatturato Netto'),
      value: data[0]?.taxable_delta,
      isBold: true,
    },
  ];

  const taxableVatData = [
    {
      title: t('Fatturato Lordo - inserito dal PdV (€)'),
      value: data[0]?.taxable_vat,
    },
    {
      title: t('Fatturato Lordo - riepilogo mensile (€)'),
      value: data[0]?.taxable_vat_monthlies,
    },
    {
      title: t('Discrepanza Fatturato Lordo'),
      value: data[0]?.taxable_vat_delta,
      isBold: true,
    },
  ];

  const receiptsData = [
    {
      title: t('Nr Scontrini - inserito dal PdV (Q.ta)'),
      value: data[0]?.receipts,
    },
    {
      title: t('Nr Scontrini - riepilogo mensile (Q.ta)'),
      value: data[0]?.receipts_monthlies,
    },
    {
      title: t('Discrepanza Nr Scontrini'),
      value: data[0]?.receipts_delta,
      isBold: true,
    },
  ];

  const piecesData = [
    { title: t('Nr Pezzi - inserito dal PdV (Q.ta)'), value: data[0]?.pieces },
    {
      title: t('Nr Pezzi - riepilogo mensile (Q.ta)'),
      value: data[0]?.pieces_monthlies,
    },
    {
      title: t('Discrepanza Nr Pezzi'),
      value: data[0]?.pieces_delta,
      isBold: true,
    },
  ];

  const columns = [
    {
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => (
        <span className={record.isBold ? styles.boldText : ''}>{text}</span>
      ),
      width: '50%',
      className: styles.columnGroupFirst,
    },
    {
      dataIndex: 'value',
      key: 'value',
      render: (text, record) => (
        <span className={record.isBold ? styles.boldText : ''}>{text}</span>
      ),
      width: '50%',
      className: styles.columnGroupSecond,
    },
  ];

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            period: moment().format('DD MMMM YYYY HH:mm'),
            company_id: '',
            file: null,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          {!loading && (
            <>
              <InfoSection
                isNew={isNew}
                shops={shops}
                inactiveShops={inactiveShops}
                period={form.getFieldValue('period')}
              />
            </>
          )}
          <>
            <div style={{ marginBottom: 20, textAlign: 'left' }}>
              <Button
                type='primary-white'
                icon={<FileExcelOutlined />}
                onClick={handleDownloadExcel}
                loading={updateInProcess}
              >
                {t('Export to Excel')}
              </Button>
            </div>
            <Table
              columns={columns}
              dataSource={taxableData}
              pagination={false}
              bordered
              size='middle'
              style={{ marginBottom: 30 }}
              showHeader={false}
              loading={loading}
              className={styles.customPaddingTable}
            />
            <Table
              columns={columns}
              dataSource={taxableVatData}
              pagination={false}
              bordered
              size='middle'
              style={{ marginBottom: 30 }}
              showHeader={false}
              loading={loading}
              className={styles.customPaddingTable}
            />
            <Table
              columns={columns}
              dataSource={receiptsData}
              pagination={false}
              bordered
              size='middle'
              style={{ marginBottom: 30 }}
              showHeader={false}
              loading={loading}
              className={styles.customPaddingTable}
            />
            <Table
              columns={columns}
              dataSource={piecesData}
              pagination={false}
              bordered
              size='middle'
              style={{ marginBottom: 30 }}
              showHeader={false}
              loading={loading}
              className={styles.customPaddingTable}
            />
          </>
        </Form>
        <NotificationFormForEdit
          approveErrors={approveErrors}
          status={singleItem.status}
          loading={updateInProcess}
          handleOnFinish={handleApprove}
          showApprove={true}
          showReject={true}
          showToAdim={false}
          showRefuse={false}
        />
      </div>
    </div>
  );
};

export default Edit;
